// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.root {
  font-family: 'Helvetica', sans-serif;
  font-size: 14px;
  margin: 0 10px;
  padding: 10px 0 5px;
  border-bottom: 1px solid #ddd;
  -webkit-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.onBottom {
  border-top: 1px solid #ddd;
  border-bottom: none;
}
`, "",{"version":3,"sources":["webpack://./node_modules/react-rte/lib/lib/EditorToolbar.css"],"names":[],"mappings":"AAAA;EACE,oCAAoC;EACpC,eAAe;EACf,cAAc;EACd,mBAAmB;EACnB,6BAA6B;EAC7B,yBAAyB;EACzB,sBAAsB;EACtB,qBAAqB;EACrB,iBAAiB;AACnB;;AAEA;EACE,0BAA0B;EAC1B,mBAAmB;AACrB","sourcesContent":[".root {\n  font-family: 'Helvetica', sans-serif;\n  font-size: 14px;\n  margin: 0 10px;\n  padding: 10px 0 5px;\n  border-bottom: 1px solid #ddd;\n  -webkit-user-select: none;\n  -moz-user-select: none;\n  -ms-user-select: none;\n  user-select: none;\n}\n\n.onBottom {\n  border-top: 1px solid #ddd;\n  border-bottom: none;\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
